import React from 'react';
import './Header.css';
import {NavLink} from 'react-router-dom';
import {connect} from 'react-redux';
import * as actions from '../../store/actions/index';



const header = (props) => (
    <header  className="KurzHeader flex gap-5 items-center">
    
         <span className="text-lg">Zobrazení:</span>
         <NavLink onClick={props.onSetDefaultOn} to='/' exact className='btn safari-btn text-white bg-gray-600 hover:text-black focus:ring-black px-4 py-2 inline-flex enabled:group flex-row justify-center gap-x-4 items-center border-none disabled:hover:text-white disabled:focus:ring-transparent'>
               Základní
         </NavLink>
        
        <NavLink onClick={props.onSetDefaultOn} to='/kompletni' className="btn safari-btn text-white bg-gray-600 hover:text-black focus:ring-black px-4 py-2 inline-flex enabled:group flex-row justify-center gap-x-4 items-center border-none disabled:hover:text-white disabled:focus:ring-transparent">
            Kompletní
        </NavLink>
    
</header>
)

const mapDispatchToProps = dispatch => {
    return {
        onSetDefaultOn: () => dispatch(actions.setDefaultOn())
    }
}

export default connect(null,mapDispatchToProps)(header);